export default __webpack_public_path__ + "static/media/CafeAvion-2.f181c674.jpg";